import React from 'react';
import './IntroSection.css';

export const IntroSection = () => {
  return (
    <section className="intro-section">
      <div className="intro-content">
        {/* Правый верхний угол с логотипами */}

        {/* Центральный блок текста */}
        <div className="intro-center-text">
          <h1>Что такое Всероссийский хакатон?</h1>
          <p>
          Хакатон – это командное соревнование по решению реальных научных задач, в котором участники смогут проявить свои знания 
          в области химии и получить опыт работы с современным оборудованием.
          </p>
        </div>

        <div className="section-divider"></div>

        {/* Нижний блок с текстом */}
        <div className="intro-bottom-text">
          <div className="text-block">
            <h2>Задача</h2>
            <p>
              Командам-участникам предстоит пройти теоретический отборочный этап, а затем в условиях химической лаборатории реализовать на практике синтез наночастиц типа «магнитное ядро»@SiО2 для очистки ДНК.
            </p>
          </div>
          
          <div className="text-block">
            <h2>Этапы</h2>
            <ol>
              <li>Теоретический тур  - решение задач по химии и нанотехнологиям в онлай формате</li>
              <li>Практический тур – работа в условиях реальной химической лаборатории, синтез готового продукта и исследование его свойств</li>
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntroSection; 